import React from 'react'
import PropTypes from 'prop-types'

export const CheckBoxCellRender = (props) => {
  const { value } = props
  return (<input type='checkbox' checked={value} disabled />)
}

CheckBoxCellRender.propTypes = {
  value: PropTypes.any,
}

export default CheckBoxCellRender
